import { Collapse, Grid, Paper } from "@mui/material";
import EditFormControl from "components/form/EditFormControl";
import CustomText from "components/typography/CustomText";
import { serverPost } from "lib/serverRequest";
import { checkWeeklySlotLog } from "models/weeklySlotsModel";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import FlavourItem from "./FlavourItem";

export default function BoxPiesList({
  pies = [],
  data = {},
  onChange = () => {},
  onChangeNote = () => {},
  onChangeCompanyName = () => {},
  onBlurCompanyName = () => {},
  onChangeRecipientName = () => {},
  onBlurRecipientName = () => {},

  onBlur = () => {},
}) {
  const [open, setOpen] = useState(false);
  const [comOpen, setComOpen] = useState(false);
  const [recipientOpen, setRecipientOpen] = useState(false);
  const prevSlotInfo = useSelector((state) => state?.app?.orderInfo ?? {});
  const authUser = useSelector((state) => state?.auth?.user ?? {});

  const handleBlur = (e) => {
    const log = checkWeeklySlotLog({ newValue: data, initData: prevSlotInfo });
    serverPost({
      url: "weeklySlots/update",
      data: {
        ...data,
        slotId: data?.id,
        log_data: Boolean(log)
          ? {
              user_id: data?.user_id ?? "",
              changer_id: authUser?.id,
              changer_type: "admin",
              box_id: data?.box_id,
              weekly_slot_id: data?.id ?? "",
              log: `${authUser?.name} ( admin ) - Order #${data?.id} - Update ${log}`,
            }
          : {},
      },
      onFinish: (res, err) => {
        onBlur(res, err);
      },
    });
  };

  return (
    <div className="flex w-full">
      <Paper className="w-full">
        <div className="p-4 flex justify-between items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            FLAVOURS
          </CustomText>
        </div>
        <div className="p-4 border-b border-white-gray">
          <Grid container spacing={2}>
            {pies.map((pie, pieIndex) => (
              <Grid item lg={3} md={3} sm={6} xs={12} key={pieIndex}>
                <FlavourItem
                  pieIndex={pieIndex}
                  pie={pie}
                  onChange={onChange}
                />
              </Grid>
            ))}
          </Grid>
        </div>
        <div className="px-3 py-1 flex items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            ORDER / RECIPIENT NAME
          </CustomText>
          <CustomText
            className="cursor-pointer ml-2 py-2 px-4"
            variant="body2"
            color="primary"
            onClick={() => setRecipientOpen((prev) => !prev)}
          >
            Edit
          </CustomText>
        </div>
        <Collapse in={recipientOpen} unmountOnExit>
          <EditFormControl
            name="box_name"
            fullWidth
            data={{
              box_name: data?.box_name ?? data?.other?.box_name,
            }}
            onChange={onChangeRecipientName}
            onBlur={onBlurRecipientName}
          />
        </Collapse>
        <div className="px-3 py-1 flex items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            ORDER / DELIVERY NOTE
          </CustomText>
          <CustomText
            className="cursor-pointer ml-2 py-2 px-4"
            variant="body2"
            color="primary"
            onClick={() => setOpen((prev) => !prev)}
          >
            Edit
          </CustomText>
        </div>
        <Collapse in={open} unmountOnExit>
          <EditFormControl
            name="delivery_note"
            type="multiline"
            fullWidth
            data={{
              delivery_note: data?.delivery_note || data?.other?.box_note,
            }}
            onChange={onChangeNote}
            onBlur={handleBlur}
          />
        </Collapse>
        <div className="px-3 py-1 flex items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            ORDER / COMPANY NAME
          </CustomText>
          <CustomText
            className="cursor-pointer ml-2 py-2 px-4"
            variant="body2"
            color="primary"
            onClick={() => setComOpen((prev) => !prev)}
          >
            Edit
          </CustomText>
        </div>
        <Collapse in={comOpen} unmountOnExit>
          <EditFormControl
            name="company_name"
            fullWidth
            data={{
              company_name: data?.company_name ?? data?.other?.company_name,
            }}
            onChange={onChangeCompanyName}
            onBlur={onBlurCompanyName}
          />
        </Collapse>
      </Paper>
    </div>
  );
}
